// UI role key -> backend role value ('user' is the backend's "Member").
export const ROLE_OWNER = "owner";
export const ROLE_ADMIN = "admin";
export const ROLE_MEMBER = "user";

export const ROLE_ORDER = [ROLE_OWNER, ROLE_ADMIN, ROLE_MEMBER];

export const ROLE_LABELS = {
  [ROLE_OWNER]: "Owner",
  [ROLE_ADMIN]: "Admin",
  [ROLE_MEMBER]: "Member",
};

// OrganizationsUsers.invite_status values (consts/crm.js OrganizationMemberStatus).
export const INVITE_STATUS_ACCEPTED = 1;
export const INVITE_STATUS_REJECTED = 2;
export const INVITE_STATUS_PENDING = 3;
